import api from "./api";

export type DeleteRoleDto = {
  id: number | string;
};
export interface createRoleDto {
  name?: string;
  permissionIds?: number[];
}
export interface roleDto {
  id?: number;
  name?: string;
  permissionIds?: number[];
  description: string;
  isActive: boolean;
  isSystem: boolean;
}
export interface ChangeRoleDto {
  roleId?: number;
  usersObj: any;
}
export const getInitialPermissions = async () => {
  return await api.get("/roles/init-permissions");
};
export const deleteRole = async (id: number) => {
  return await api.delete(`/roles/${id}`);
};
export const createRole = async (body: roleDto) => {
  return await api.post("/roles", {
    name: body.name,
    permissionIds: body.permissionIds,
    description: body.description,
    isActive: body.isActive,
    isSystem: body.isSystem,
  });
};
export const getRoleById = async (roleId: string | undefined) => {
  return await api.get(`/roles/${roleId}`);
};
export const editRole = async (body: roleDto) => {
  return await api.put(`/roles/${body.id}`, {
    name: body.name,
    permissionIds: body.permissionIds,
    description: body.description,
    isActive: body.isActive,
    isSystem: body.isSystem,
  });
};

export const getRoles = async (
  isActive: boolean | undefined,
  q: string,
  page: number
) => {
  let route = "/roles";

  if (isActive !== undefined) {
    route += `?isActive=${isActive}&q=${q}`;
  } else {
    route += `?q=${q}`;
  }
  route += `&limit=${page * 10 + 10}`;

  return await api.get(route);
};
export const getRolesDropdown = async () => {
  return await api.get(`/roles/dropdown`);
};
export const getUsersForRole = async (roleId: string | undefined) => {
  return await api.get(`/roles/${roleId}/users`);
};
export const changeUsersRole = async ({ roleId, userIds }: any) => {
  return await api.post(`/roles/${roleId}/users`, {
    userIds,
  });
};
